import { Button } from './../../../button';
import styled from 'styled-components';
import { getSizeBy, getColorShade } from '../../../../../src/styled/utils';
import { Menu } from '../../../menu';
import { Icon } from '../../../icon';
import { ListItemContent } from '../../../list-item-content';
import { List } from '../../../list';
import { ListItem } from '../../../list-item';
import { Subtitle1, Subtitle2 } from '../../../typography';
export const StyledMenu = styled(Menu) `
  margin-left: ${(props) => { var _a; 
/* @ts-ignore */
return ((_a = props.position) === null || _a === void 0 ? void 0 : _a.includes('start')) ? '10px' : '0'; }};
`;
export const StyledButton = styled(Button) `
  padding-right: ${getSizeBy(2)};
  padding-left: ${getSizeBy(2)};

  > .text {
    padding-right: ${getSizeBy(2)};
    padding-left: ${getSizeBy(2)};
  }
`;
export const BookmarkIcon = styled(Icon).attrs({ name: 'bookmark' }) ``;
export const StyledListItemContent = styled(ListItemContent) `
  justify-content: center;
`;
export const StyledDropBlock = styled.div `
  display: flex;
  flex-direction: column;
  width: 486px;
  height: 396px;
  border: 0.5px solid ${getColorShade('onSurface', 'outline')};
  border-radius: 6px;
`;
export const StyledScrollable = styled(List) `
  flex: 1 1 auto;
  overflow-y: auto;
`;
export const StyledBottom = styled(List) `
  flex: 0 0 0;
`;
export const StyledFirstItem = styled(ListItem) `
  > div {
    padding: 0;
  }
`;
export const StyledListHeading = styled(Subtitle1) `
  color: ${getColorShade('onSurface', 'lowEmphasis')};
`;
export const EmptyDropdownContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 46px 0;
`;
export const StyledEmptyHeading = styled(Subtitle2) `
  max-width: 180px;
  margin: ${getSizeBy(4)} auto 0;
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  text-align: center;
`;
